// Turned off in Step 8 is saved as [], never saved is null: both mean no happiness check (Alpha-910).
export function hasHappinessCheck(
  campaign?: { happinessCheck?: unknown } | null,
): boolean {
  const form = campaign?.happinessCheck
  return Array.isArray(form) && form.length > 0
}
